<template>
  <v-popup
    :class="bem()"
    :value="show"
    :position="position"
    v-backFn="{ show: show, closeFn: 'close' }"
    @change="$emit('input', $event.target.value)"
    @click-overlay="close"
  >
    <div :class="bem('container')" :style="{ height: height }">
      <div :class="bem('header')">
        <div :class="bem('title')">{{ title }}</div>
        <img :class="bem('close')" src="./images/close.png" alt="" @click="close" />
      </div>
      <div :class="bem('content')">
        <slot />
      </div>
    </div>
  </v-popup>
</template>

<script>
import create from '../create'

export default create({
  name: 'popups-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    // 是否显示
    show: {
      type: false,
      default: false
    },
    // 弹窗高度占全屏的百分比
    height: {
      type: String,
      default: 'auto'
    },
    position: {
      type: String,
      default: 'bottom'
    },
    // 弹窗标题
    title: String,
    // 底部按钮点击事件
    footerShow: {
      type: Boolean,
      default: true
    },
    // 底部按钮文案
    footerText: {
      type: String,
      default: '确定'
    }
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('close')
    },
    footerClick() {
      this.$emit('footerClick')
    }
  }
})
</script>
<style lang="scss" scoped src="./index.scss"></style>
